import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useFetchData from '../../../hooks/useFetchData';
import styles from '../../Encoder/capsule.module.scss';
import Toolbar from '../../Toolbar/Toolbar';
import { ContentLayoutProvider, useContentLayout } from '../../../context/ContentLayout';
import { Helmet } from 'react-helmet-async';
import LoadingSpinner from '../../Common/Loading/LoadingSpinner';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';

const dilutionsData = [
    {
        letter: "A",
        encoding: "! Atténuer, Contraire légitime, Efficace",
        sort: 1
    },
    {
        letter: "R",
        encoding: "! Renforcer, normal, Efficace",
        sort: 2
    },
    {
        letter: "S",
        encoding: "! Syntoniser, Dans son assertion allégorique, Efficace",
        sort: 3
    },
    {
        letter: "E",
        encoding: "! Effluence, Normal, Répétition",
        sort: 4
    },
    {
        letter: "T-08 E",
        encoding: "! 40/3.2, Profond, Interaction",
        sort: 5
    },
    {
        letter: "T-10 E",
        encoding: "! 40/4, Transmutation , réactiver",
        sort: 6
    },
    {
        letter: "T-12 E",
        encoding: "! 40/4.8, Interaction, réactiver",
        sort: 7
    },
    {
        letter: "Sans",
        encoding: "! 1:1, Dans son assertion allégorique, Efficace  ",
        sort: 8
    },
    // Ajoutez d'autres dilutions au besoin
];

const dilutions = {};
dilutionsData.forEach((dilution) => {
    dilutions[dilution.letter] = dilution;
});
const SelectionDisplay = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data, error, isLoading } = useFetchData(`/selections/${id}`);
    const { layoutConfig, checkColumns, resetFontsize, resetColumn, checkFontsize } = useContentLayout(); // Utilisez le contexte
    const [currentDilution, setCurrentDilution] = useState(null);
    const [isDisplay, setIsDisplay] = useState(true);

    const containerRef = useRef(null);

    const getFirstDilution = () => {
        // Get all dilutions of objects in data and sort it
        if (!data) { return }

        const sortedDilutions = [...new Set(data.mixtures.map((capsule) => capsule.dilution))].sort((a, b) => {
            return dilutions[a].sort - dilutions[b].sort
        });
        console.log(sortedDilutions)

        setCurrentDilution(dilutions[sortedDilutions[0]])
    }


    const sortedData = useMemo(() => {
        if (!isLoading) {
            console.log(data)
            const sortedDilutions = [...new Set(data.mixtures.map((capsule) => capsule.dilution))].sort((a, b) => {
                return dilutions[a].sort - dilutions[b].sort
            });
            if (!currentDilution) {
                setCurrentDilution(dilutions[sortedDilutions[0]])
            }
            return currentDilution ? data.mixtures.filter((capsule) => capsule.dilution === currentDilution.letter) : data.mixtures.filter((capsule) => capsule.dilution === sortedDilutions[0])
        }

    }, [data, currentDilution, isLoading]);

    const toggleToolbar = (event) => {
        if (event.ctrlKey && event.code === 'KeyA') {
            setIsDisplay(!isDisplay);
        }
    };

    const resetContentStyles = () => {
        // Réinitialisez les styles CSS pour afficher le contenu en une seule colonne.
        const container = containerRef.current;
        if (container) {
            container.style.columnCount = 1;
        }
    };

    const checkWindowSize = () => {
        resetContentStyles(); // Réinitialisez la disposition à une colonne.
    };

    const handleOrderSelection = () => {
        navigate(`/selections/commander/${id}`);
    };

    useEffect(() => {
        document.addEventListener('keydown', toggleToolbar);

        return () => {
            document.removeEventListener('keydown', toggleToolbar);
        };
    }, [isDisplay]); // Assurez-vous que ce code s'exécute une seule fois lors du montage

    useEffect(() => {
        if (!isLoading) {
            getFirstDilution()
        }
    }, [data, isLoading]);

    useEffect(() => {
        checkColumns(); // Exécutez la vérification initiale.
        checkFontsize();
    }, [sortedData, currentDilution]);


    if (isLoading) return <LoadingSpinner style="medium" />

    return (
        <>
            <Helmet>
                <title>{data._id}</title>
            </Helmet>

            {error && <p>{error.request.status === 403 ? 'Unauthorized' : error.message}</p>}
            {isDisplay && (
                <div className={styles.toolbarContainer}>
                    <Toolbar checkWindowSize={checkWindowSize} fontSize={layoutConfig.fontSize} columnCount={layoutConfig.columns} />
                    {data.mixtures && dilutionsData.sort((a, b) => a.sort - b.sort).map((dilution, index) => {
                        if (data.mixtures.some((capsule) => capsule.dilution === dilution.letter)) {
                            return (
                                <button style={{ background: currentDilution === dilution ? '#63cdf5' : 'white' }} key={index} onClick={() => {
                                    if (currentDilution !== dilution) {
                                        console.log('change dilution')
                                        setCurrentDilution(dilution);
                                        resetColumn();
                                        resetFontsize();
                                    }
                                }}>
                                    {dilution.letter}
                                </button>
                            );
                        }
                        return null;
                    })}
                    
                    {/* Bouton de commande */}
                    <button 
                        className="ml-auto flex items-center gap-2 bg-primary text-white px-4 py-2 rounded-lg hover:bg-primary-dark transition-colors"
                        onClick={handleOrderSelection}
                    >
                        <ShoppingCartIcon className="h-5 w-5" />
                        Commander
                    </button>
                </div>
            )}

            <div style={{ padding: '20px' }}>
                <div ref={containerRef} className={styles.container} style={{ fontSize: `${layoutConfig.fontSize}px`, columnCount: layoutConfig.columns }}>

                    {sortedData && sortedData.map((mixture, index) => {

                        return (
                            <div key={index}>
                                <p> {mixture.secondary_category.toUpperCase()}</p>
                                <p>{mixture.name} {dilutions[mixture.dilution].encoding} {"{"}</p>
                                {mixture.reagents.split(" , ").map((reagents, index) => (
                                    <p key={`reagent_${index}`}>{reagents}</p>
                                ))}
                                <p>{"}"}</p>
                                <br />
                                <br />
                            </div>
                        )
                    })}
                </div>
            </div>

        </>
    );
}

const Selection = () => {
    return (

        <ContentLayoutProvider>
            <SelectionDisplay />
        </ContentLayoutProvider>

    )
}

export default Selection;
